import { Link } from "@mui/material";
import { useIntersectionObserver, useWindowSize } from "@uidotdev/usehooks";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import esclip1 from "../../assets/imgs/homepage/Ellipse 154.png";
import esclip from "../../assets/imgs/homepage/Ellipse 155.png";
import girl from "../../assets/imgs/homepage/Rectangle-Copy.png";
import balance from "../../assets/svgs/apibanking/blacee.svg";
import bulk from "../../assets/svgs/apibanking/bulk.svg";
import soundbox from "../../assets/svgs/apibanking/header.svg";
import check from "../../assets/svgs/check.svg";
import frequent from "../../assets/svgs/frenquent.svg";
import payment from "../../assets/svgs/payment.svg";
import poor from "../../assets/svgs/poor.svg";
import sound from "../../assets/svgs/upi/codebusiness.svg";
import retail from "../../assets/svgs/upi/ecom.svg";
import bankacc from "../../assets/svgs/upi/kyc.svg";
import esay from "../../assets/svgs/upi/onboar.svg";
import checkhow from "../../assets/svgs/upi/paycollect.svg";
import cafehrer from "../../assets/svgs/upi/scan.svg";
import online from "../../assets/svgs/upi/useby.svg";
import cafe from "../../assets/svgs/upi/useful.svg";
import { AccordionComponent } from "../../components/accordions";
import { ButtonNumber, LeafButton } from "../../components/buttons";
import { Contact } from "../../components/contact/Contact";
import { SliderdotUpiqr } from "../../components/slicksdiler";
import { HaveALookItem, SoundBoxWorkItem } from "../../components/soundboxwork";
import { UpiSoundboxItem } from "../../components/upisoundbox/UpiSoundboxItem";
export const Upi = () => {
  const { width } = useWindowSize();
  const { t, i18n } = useTranslation();

  const [currentTitle, setCurrentTitle] = useState(t("upiqrcode.low"));
  const [currentHeader, setCurrentHeader] = useState(t("upiqrcode.lowdes"));
  const handleButtonClick1 = () => {
    setCurrentTitle(t("upiqrcode.low"));
    setCurrentHeader(t("upiqrcode.lowdes"));
  };

  const handleButtonClick2 = () => {
    setCurrentTitle(t("upiqrcode.remote"));
    setCurrentHeader(t("upiqrcode.remotedes"));
  };
  const handleButtonClick3 = () => {
    setCurrentTitle(t("upiqrcode.intero"));
    setCurrentHeader(t("upiqrcode.interodes"));
  };
  const handleButtonClick4 = () => {
    setCurrentTitle(t("upiqrcode.push"));
    setCurrentHeader(t("upiqrcode.pushdes"));
  };
  const handleButtonClick5 = () => {
    setCurrentTitle(t("upiqrcode.noneed"));
    setCurrentHeader(t("upiqrcode.noneeddes"));
  };
  useEffect(() => {
    if (activeButton == 1) {
      setCurrentTitle(t("upiqrcode.low"));
      setCurrentHeader(t("upiqrcode.lowdes"));
    } else if (activeButton == 2) {
      setCurrentTitle(t("upiqrcode.remote"));
      setCurrentHeader(t("upiqrcode.remotedes"));
    } else if (activeButton == 3) {
      setCurrentTitle(t("upiqrcode.intero"));
      setCurrentHeader(t("upiqrcode.interodes"));
    } else if (activeButton == 4) {
      setCurrentTitle(t("upiqrcode.push"));
      setCurrentHeader(t("upiqrcode.pushdes"));
    } else {
      setCurrentTitle(t("upiqrcode.noneed"));
      setCurrentHeader(t("upiqrcode.noneeddes"));
    }
  }, [t]);

  const [activeButton, setActiveButton] = useState(1); // State để theo dõi nút hiện đang được kích hoạt

  const handleButtonClick = (buttonNumber) => {
    setActiveButton(buttonNumber); // Cập nhật state để chỉ định nút được kích hoạt
  };
  const [ref, entry] = useIntersectionObserver({
    threshold: 0,
    root: null,
    rootMargin: "0px",
  });
  const [ref1, entry1] = useIntersectionObserver({
    threshold: 0,
    root: null,
    rootMargin: "0px",
  });
  const [ref2, entry2] = useIntersectionObserver({
    threshold: 0,
    root: null,
    rootMargin: "0px",
  });

  const [isVisible, setIsVisible] = useState(false);
  const [isVisible1, setIsVisible1] = useState(false);
  const [isVisible2, setIsVisible2] = useState(false);
  useEffect(() => {
    if (entry && entry.isIntersecting && !isVisible) {
      setIsVisible(true); // Đánh dấu đã gặp isIntersecting
    }
  }, [entry, isVisible]);
  useEffect(() => {
    if (entry1 && entry1.isIntersecting && !isVisible1) {
      setIsVisible1(true); // Đánh dấu đã gặp isIntersecting
    }
  }, [entry1, isVisible1]);
  useEffect(() => {
    if (entry2 && entry2.isIntersecting && !isVisible2) {
      setIsVisible2(true); // Đánh dấu đã gặp isIntersecting
    }
  }, [entry2, isVisible2]);

  return (
    <div className="relative mt-[145px]">
      <Helmet>
        <title>{t("upiqrcode.tabTitle")} | Trusted Pay</title>
      </Helmet>
      <img className="absolute left-0 top-[0]" src={esclip} alt="" />
      <img className="absolute right-0 top-[0]" src={esclip1} alt="" />
      <div className="absolute left-[50%] top-[50px] h-[24px] w-[24px] animate-movesquare rounded-[24px] bg-[#FF9B26]"></div>
      <div className="absolute left-[40%] top-[450px] h-[42px] w-[39px] animate-movesquare-slow rounded-[24px] bg-[#565ADD]"></div>

      {/* SOUNDBOX */}
      <div className="relative mx-auto max-w-[1280px] px-4 mothaibaysaimin:px-8">
        {width > 1024 ? (
          <div className="flex items-center gap-[30px] sm:flex-col">
            <div className="max-w-[625px] ">
              <p className="animate-fadeInDown text-[40px] font-bold text-[--color-text]">
                {t("upiqrcode.header")}
              </p>
              <div className="animate-fadeInUp">
                <p className="text-4 mt-[20px] max-w-[625px] font-semibold text-[--color-text] ">
                  {t("upiqrcode.headerdes")}
                </p>
                <LeafButton
                  title={t("apibanking.contactsale")}
                  style={{ marginTop: "36px" }}
                />
              </div>
            </div>
            <div className="relative">
              <img
                className="h-[500px] w-[606px] lg:w-[500px] lgmax:h-[400px]"
                src={soundbox}
                alt=""
              />
              <div className="absolute top-0 left-1/3 -z-10">
                <div className="absolute left-0 top-[-20px] h-[500px] w-[500px] animate-spin rounded-[50%] border border-solid border-blue-200">
                  <div className="absolute left-[200px] top-[-5px] h-[14px] w-[14px] rounded-[50%] bg-[#FF9B26]"></div>
                </div>
                <div className="absolute left-[40px] top-[16px] h-[420px] w-[420px] rounded-[50%] border border-solid border-blue-200"></div>
                <div className="absolute left-[80px] top-[52px] h-[340px] w-[340px] animate-spin rounded-[50%] border border-solid border-blue-200">
                  <div className="absolute left-[200px] top-[-5px] h-[14px] w-[14px] rounded-[50%] bg-[#565ADD]"></div>
                </div>
                <div className="absolute left-[120px] top-[82px] h-[260px] w-[260px] rounded-[50%] border border-solid border-blue-200"></div>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex animate-fadeInDown items-center gap-[30px] sm:flex-col">
            <div className="relative">
              <img
                className="h-[500px] w-[606px] lg:w-[500px] lgmax:h-[400px]"
                src={soundbox}
                alt=""
              />
              <div className="absolute top-0 -z-10">
                <div className="absolute left-0 top-[-20px] h-[500px] w-[500px] animate-spin rounded-[50%] border border-solid border-blue-200">
                  <div className="absolute left-[200px] top-[-5px] h-[14px] w-[14px] rounded-[50%] bg-[#FF9B26]"></div>
                </div>
                <div className="absolute left-[40px] top-[16px] h-[420px] w-[420px] rounded-[50%] border border-solid border-blue-200"></div>
                <div className="absolute left-[80px] top-[52px] h-[340px] w-[340px] animate-spin rounded-[50%] border border-solid border-blue-200">
                  <div className="absolute left-[200px] top-[-5px] h-[14px] w-[14px] rounded-[50%] bg-[#565ADD]"></div>
                </div>
                <div className="absolute left-[120px] top-[82px] h-[260px] w-[260px] rounded-[50%] border border-solid border-blue-200"></div>
              </div>
            </div>
            <div className="max-w-[625px]">
              <p className="text-[40px] font-bold text-[--color-text] ">
                {t("upiqrcode.header")}
              </p>
              <p className="text-4 mt-[20px] max-w-[625px] font-semibold text-[--color-text]">
                {t("upiqrcode.headerdes")}
              </p>
              <LeafButton
                title={t("apibanking.contactsale")}
                style={{ marginTop: "36px" }}
              />
            </div>
          </div>
        )}
      </div>
      <div ref={ref}>
        <div
          className={`relative mx-auto max-w-[1280px] px-[80px] py-[50px] sm:px-4  ${isVisible ? "animate-fadeInUp" : null}`}
        >
          <div className="flex flex-col items-center justify-center gap-[20px]">
            <div className="group">
              <img
                src={sound}
                className=" animate-spin  transition-all group-hover:animate-hover"
                alt=""
              />
            </div>

            <h1 className="max-w-[1240px]  text-center text-[36px] font-bold text-[--color-title]">
              {t("upiqrcode.understanding")}{" "}
              <span className="text-[--color-hover]">
                {t("upiqrcode.code")}
              </span>
            </h1>

            <p className="text-4  text-center font-montserrat text-[--color-text]">
              {t("upiqrcode.code1")}
              <Link
                style={{ textDecoration: "none" }}
                to="https://www.npci.org.in/"
              >
                <span className="cursor-pointer text-[--color-hover] hover:underline">
                  {t("upiqrcode.code2")}
                </span>
              </Link>
              {t("upiqrcode.code3")}
            </p>
          </div>
        </div>
      </div>

      <div ref={ref1}>
        <div
          className={`rounded-tr-[200px] bg-[#EFF0FF] sm:rounded-tl-[50px] sm:rounded-tr-[50px] ${isVisible1 ? "animate-fadeInUp" : null}`}
        >
          <div className="mx-auto flex max-w-[1280px] flex-col gap-[20px] px-[50px] py-[50px] sm:px-4">
            <h1 className="max-w-[1240px] text-center text-[36px] font-bold text-[--color-title]">
              {t("upiqrcode.howdoes")}{" "}
              <span className="text-[--color-hover]">
                {t("upiqrcode.codebusiness")}{" "}
              </span>
            </h1>
            <div className="flex  lgmax:flex-wrap lgmax:justify-center">
              <SoundBoxWorkItem
                image={esay}
                titleheader={t("upiqrcode.onboaring")}
                title={t("upiqrcode.onboardingdes")}
              />
              <div
                className={` ${check ? width : "max-w-[426px] lgmax:max-w-none"}  groupHover group flex flex-col gap-[20px] px-[20px] py-[10px] sm:px-0`}
              >
                <img
                  className="h-[152px] w-[200px] group-hover:animate-hover"
                  src={bankacc}
                  alt=""
                />

                <div className="flex flex-col gap-[10px]">
                  <h3 className="hoverText    bg-[-100%] text-[20px] font-bold text-[--color-hover] group-hover:animate-text group-hover:bg-[0] group-hover:text-[#2B1C50]">
                    {t("upiqrcode.kyc")}
                  </h3>
                  <div className="h-[4px] max-w-[260px] bg-[#565ADD] group-hover:bg-[#2B1C50]"></div>
                  <p className="text-4 hoverTextChild font-normal text-[--color-text]">
                    {" "}
                    {t("upiqrcode.kycdes1")}{" "}
                    <span className="font-bold">{t("upiqrcode.kycdes2")}</span>{" "}
                    {t("upiqrcode.kycdes")}
                  </p>
                </div>
              </div>
              <SoundBoxWorkItem
                image={checkhow}
                titleheader={t("upiqrcode.payment")}
                title={t("upiqrcode.paymentdes")}
              />
            </div>
          </div>
        </div>
      </div>

      <div ref={ref2}>
        <div
          className={`relative h-[570px]  bg-soundbox bg-cover bg-center bg-no-repeat sm:h-full lg:h-[620px]   ${isVisible2 ? "animate-fadeInUp" : null}`}
        >
          <div
            className="absolute bottom-0 left-0 right-0  top-0 h-[570px] bg-soundboxOverlay opacity-[0.63] sm:h-full
                lg:h-[620px] "
          ></div>
          <div className="left-26 absolute z-[100] h-0 w-48 border-dashed  border-white bg-white"></div>
          <div className={`relative  mx-auto max-w-[1280px] px-4 py-[70px]`}>
            <div>
              <h1 className="max-w-[1240px]  text-center text-[36px] font-bold text-[#fff]">
                {t("upiqrcode.limitations")}{" "}
                <span className="text-[--color-hover]">
                  {t("upiqrcode.theqr")}
                </span>{" "}
              </h1>
              <div>
                <div className="absolute left-[17%] top-[31.5%] w-[65%] border-[1px] border-dashed border-white sm:hidden"></div>
                <div className="absolute left-[17%] top-[31.05%] w-[65%] border-[1px] border-dashed border-white sm:hidden"></div>
                <div className="relative flex sm:flex-col sm:items-center sm:justify-center sm460:gap-[30px] ">
                  <UpiSoundboxItem
                    image={payment}
                    titleheader={t("upiqrcode.returnning")}
                    title={t("upiqrcode.returnningdes")}
                    height={"lgmin:min-h-[340px]"}
                  />
                  <UpiSoundboxItem
                    image={frequent}
                    titleheader={t("upiqrcode.down")}
                    title={t("upiqrcode.downdes")}
                    height={"lgmin:min-h-[340px]"}
                  />
                  <UpiSoundboxItem
                    image={poor}
                    titleheader={t("upiqrcode.tracking")}
                    title={t("upiqrcode.trackingdes")}
                    height={"lgmin:min-h-[340px]"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="min-h-[640px] bg-[#EFF0FF] sm:min-h-[800px] lg:min-h-[580px]">
        <div className="mx-auto max-w-[1400px] flex-col gap-[20px] px-[50px]  py-[50px] sm:px-[16px]">
          <h1 className="ml-[30px] max-w-[1240px] text-center text-[36px] font-bold text-[--color-title] sm:ml-0">
            {t("upiqrcode.theqr")}{" "}
            <span className="text-[--color-hover]">
              {t("upiqrcode.benebold")}{" "}
            </span>
          </h1>
          <SliderdotUpiqr />
        </div>
      </div>

      <div className="relative bg-white ">
        <div
          className={`mx-auto flex max-w-[1280px] items-center justify-center px-4 py-[50px] pt-[50px] sm:flex-wrap lg:flex-wrap`}
        >
          <div className="relative max-w-[640px]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="sm:w-[400px]"
              width="544"
              height="544"
              viewBox="0 0 544 544"
              fill="none"
            >
              <path
                opacity="0.03"
                d="M271.751 0.350098C421.618 0.350098 543.109 121.841 543.109 271.707C543.109 421.573 421.618 543.065 271.751 543.065C121.885 543.065 0.394043 421.574 0.394043 271.707C0.394043 121.841 121.885 0.350098 271.751 0.350098Z"
                fill="#2B1C50"
              />
            </svg>
            <div className=" absolute left-[60px] top-[60px] h-[420px]  w-[420px] rounded-[50%] border border-dashed  border-[#565ADD] sm:left-[46px] sm:top-[124px] sm:h-[300px] sm:w-[300px]"></div>
            <img
              className="absolute left-0 top-0 ml-[95px] mt-[26px] sm:ml-[85px] sm:mt-[112px] sm:w-[268px] mothaibaysaimin:w-[383px]"
              src={girl}
              alt=""
            />
          </div>
          <div className="ml-[60px] sm:ml-0 lgmax:ml-0">
            <h1 className="max-w-[620px]  text-[36px] font-bold text-[--color-title]">
              {t("upiqrcode.usecases")}
              <span className="text-[--color-hover]">
                {i18n.language === "en" ? " UPI/QR Code" : " Mã UPI/QR"}{" "}
              </span>
            </h1>
            {}

            <HaveALookItem
              image={cafe}
              titleheader={t("upiqrcode.usefull")}
              title={t("upiqrcode.usefulldes")}
              bottomValue={
                i18n.language === "en" ? "bottom-[16px]" : "bottom-[40px]"
              }
              paddingleft={"pl-[18px]"}
            />

            <HaveALookItem
              image={cafehrer}
              titleheader={t("upiqrcode.used")}
              title={t("upiqrcode.useddes")}
              bottomValue={
                i18n.language === "en" ? "bottom-[88px]" : "bottom-[112px]"
              }
              paddingleft={"pl-[18px]"}
            />

            <HaveALookItem
              image={retail}
              titleheader={t("upiqrcode.ecommer")}
              title={t("upiqrcode.ecommerdes")}
              bottomValue={
                i18n.language === "en" ? "bottom-[40px]" : "bottom-[40px]"
              }
              paddingleft={"pl-[18px]"}
            />

            <HaveALookItem
              image={online}
              titleheader={t("upiqrcode.useby")}
              title={t("upiqrcode.usebydes")}
              bottomValue={
                i18n.language === "en" ? "bottom-[16px]" : "bottom-[-10px]"
              }
              paddingleft={"pl-[18px]"}
            />
          </div>
        </div>
      </div>
      <div className="rounded-t-3xl bg-pupletowhite ">
        <div className="mx-auto max-w-[1280px] flex-col justify-between px-4 py-[50px] sm:py-0 lgmaxmin:flex-col lgmaxmin:items-center">
          <h1 className="pb-[15px] text-[36px] font-bold text-white space-x-1">
            {i18n.language === "vi" ? (
              <>
                <span className="text-[#D1D1F7]">{t("upiqrcode.why2")}</span>
                <span>{t("of")}</span>
                <span>Trusted Pay</span>
              </>
            ) : (
              <>
                <span>Trusted Pay's</span>
                <span className="text-[#D1D1F7]">{t("bbsp.allin")}</span>
              </>
            )}
          </h1>
          <p className="text-4 text-white">{t("upiqrcode.solutiondes")}</p>
          <div className="mt-[20px] flex lgmax:flex-col lgmax:gap-[30px]">
            <div
              className={`transition-border  transition-radius mr-[30px] rounded-[20px] transition-colors transition-shadow duration-500 duration-500 duration-500  ease-in-out hover:shadow-have-a-look-hover  sm:mr-0  ${i18n.language === "en" ? (width > 1230 ? "h-[328px]" : "h-none") : ""}  relative overflow-hidden  sm:mr-0`}
            >
              <div
                className={`mb-[1px] flex max-w-[600px]   flex-col rounded-[20px] bg-white  p-[20px]  lgmax:max-w-none `}
              >
                <div className="h-[100px] w-[100px] rounded-[50px]  shadow-benefits">
                  <img className="p-[25px]" src={balance} alt="" />
                </div>
                <div className="mt-[25px] flex flex-col gap-[10px]">
                  <h3 className="bg-[-100%] text-[24px] font-semibold text-[--color-hover]">
                    {t("upiqrcode.staticQr")}
                  </h3>
                  <p className="text-4  font-normal text-[--color-text] group-hover:animate-text">
                    {t("upiqrcode.staticQrdes1")}
                    <a href="#" className="text-[#565ADD] hover:underline">
                      {t("upiqrcode.staticQrdes2")}
                    </a>
                    {t("upiqrcode.staticQrdes")}
                  </p>
                </div>
              </div>
            </div>
            <div
              className={`transition-border  transition-radius mr-[30px] rounded-[20px] transition-colors transition-shadow duration-500 duration-500 duration-500  ease-in-out hover:shadow-have-a-look-hover  sm:mr-0  ${i18n.language === "en" ? (width > 1230 ? "h-[328px]" : "h-none") : ""}  relative overflow-hidden  sm:mr-0`}
            >
              <div
                className={`mb-[1px] flex max-w-[600px]   flex-col rounded-[20px] bg-white  p-[20px]  lgmax:max-w-none `}
              >
                <div className="h-[100px] w-[100px] rounded-[50px]  shadow-benefits">
                  <img className="p-[25px]" src={bulk} alt="" />
                </div>
                <div className="mt-[25px] flex flex-col gap-[10px]">
                  <h3 className="bg-[-100%] text-[24px] font-semibold text-[--color-hover]">
                    {t("upiqrcode.dynamic")}
                  </h3>
                  <p className="text-4  font-normal text-[--color-text] group-hover:animate-text">
                    {t("upiqrcode.dynamicdes1")}{" "}
                    <a href="#" className="text-[#565ADD] hover:underline">
                      {t("upiqrcode.dynamicdes2")}
                    </a>{" "}
                    {t("upiqrcode.dynamicdes")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white sm:py-[50px]">
        <div className="mx-auto flex max-w-[1280px] justify-between px-4 py-[50px] pt-[50px] sm:py-0 lgmaxmin:flex-col lgmaxmin:items-center">
          <div className={`mr-[10px] flex flex-1 flex-col gap-[20px]`}>
            <h1 className="max-w-[520px] text-[36px] font-bold  text-[--color-title] lgmaxmin:max-w-[850px]">
              {t("upiqrcode.whychoose")}
              <span className="text-[--color-hover]"> UPI/QR Code</span>?
            </h1>
            <p className="text-4 max-w-[620px] font-montserrat text-[#3D2E7C] lgmaxmin:max-w-[850px]">
              {t("upiqrcode.whychoosedes")}
            </p>
            <div className="group flex items-start gap-[30px] p-4 sm:flex-col sm:items-center">
              <img
                className="group-hover:animate-hover sm:h-[43px] sm:w-[43px]"
                src={check}
                alt=""
              />
              <div className="sm:text-center">
                <p className="border-b-solid inline-block border-b-4 border-b-[#f1f1f1] pb-[12px] text-[24px] font-bold text-[#333]">
                  {currentTitle}
                </p>

                <p className="text-4 mt-[10px]  font-normal text-[#3D2E7C] lg:max-w-[650px]">
                  {currentHeader}
                </p>
              </div>
            </div>
            <div className="flex gap-[30px] sm:gap-[5px] ">
              <ButtonNumber
                title={"1"}
                onClick={() => {
                  handleButtonClick1();
                  handleButtonClick(1);
                }} // Gọi hai hàm xử lý sự kiện
                isActive={activeButton === 1}
              />
              <ButtonNumber
                title={"2"}
                onClick={() => {
                  handleButtonClick2();
                  handleButtonClick(2);
                }} // Gọi hai hàm xử lý sự kiện
                isActive={activeButton === 2}
              />
              <ButtonNumber
                title={"3"}
                onClick={() => {
                  handleButtonClick3();
                  handleButtonClick(3);
                }} // Gọi hai hàm xử lý sự kiện
                isActive={activeButton === 3}
              />
              <ButtonNumber
                title={"4"}
                onClick={() => {
                  handleButtonClick4();
                  handleButtonClick(4);
                }} // Gọi hai hàm xử lý sự kiện
                isActive={activeButton === 4}
              />
              <ButtonNumber
                title={"5"}
                onClick={() => {
                  handleButtonClick5();
                  handleButtonClick(5);
                }} // Gọi hai hàm xử lý sự kiện
                isActive={activeButton === 5}
              />
            </div>
          </div>
          <div className="flex flex-1 flex-col gap-[20px]  lg:mt-[20px] lgmax:mt-[20px]">
            <h1 className="max-w-[520px] text-[36px] font-bold text-[--color-title]">
              FA<span className="text-[--color-hover]">Q's</span>
            </h1>
            <AccordionComponent
              header1={t("upiqrcode.whatdo")}
              des1={t("upiqrcode.whatdodes")}
              header2={t("upiqrcode.whatare")}
              des2={t("upiqrcode.whataredes")}
              header3={t("upiqrcode.howdo")}
              header4={t("upiqrcode.whattype")}
              des4={t("upiqrcode.whattypedes")}
              header5={t("upiqrcode.howdowe")}
              des5={t("upiqrcode.howdowedes")}
              check3={true}
            />
          </div>
        </div>
      </div>

      <Contact
        header={t("apibanking.contact")}
        headertitle={t("apibanking.withus")}
        headerdes={t("upiqrcode.contactdes")}
        headerdes2={t("upiqrcode.contactdes2")}
        headerdes3={t("upiqrcode.contactdesStrong")}
      />
    </div>
  );
};
